
import { useGetAllAreasQuery } from 'generated/graphql';

import React from 'react';

export interface IData {
  id: string;
  name: string;
  displayName: string;
}

export function useQuery() {
  const tuple = useGetAllAreasQuery({
    variables: {
    }
  });

  return React.useMemo(
    () => {
      const data: IData[] = tuple.data?.areas.map((node) => ({
        id: node.id,
        name: node.name,
        displayName: node.displayName
      })) ?? [];


      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
